import { useTranslation } from 'react-i18next';
import { BackButton } from '@/components/BackButton';
import { useFundraisingStatusById } from '@/hooks/shared/useFundraisingStatusById';
import { FR_APPLICATION_STATUSES, FR_STEPS } from '@/helpers/fundraising';
import { FundraisingSummary } from '../../components/FundraisingSummary';
import { FoundersConfirmation } from '../FoundersConfirmation';
import { BorrowerConfirmBlock } from '../BorrowerConfirmBlock';
import { BorrowerMessages } from '../BorrowerMessages';
import { LoanTermStatus } from '../LoanTerms';
import s from './index.module.scss';

export const BorrowerFundraisingInfo = ({ fundraisingId, application, onBack }) => {
  const { status } = useFundraisingStatusById(fundraisingId);
  const { t } = useTranslation();

  if (!status) return null;

  const showSummary = [FR_STEPS.awaiting_borrower_guarantor, FR_STEPS.fundraising_summary].includes(
    status.step,
  );

  const isApproved = application?.status === FR_APPLICATION_STATUSES.APPROVED;

  return (
    <div className={s.wrapper}>
      <div className="container-inner">
        <div className={s.content}>
          <BackButton onClick={onBack} />
          <h1 className="f-hero-h2">{t('fundraising:page.title')}</h1>
          <BorrowerMessages status={status} application={application} />
          {application && isApproved ? (
            <FundraisingSummary newFunds={status.new_funds} refinances={status.refinances} />
          ) : (
            <FundraisingSummary
              newFunds={application.new_funds}
              refinances={application.refinancings}
            />
          )}
          {showSummary && (
            <>
              <LoanTermStatus status={status} />
              <FoundersConfirmation />
            </>
          )}
        </div>
      </div>
      {status.step === FR_STEPS.awaiting_borrower_guarantor && (
        <BorrowerConfirmBlock fundraisingId={fundraisingId} />
      )}
    </div>
  );
};
